import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { BreadCrumbs, ContentBody, Section } from '@lanl-web/lanl-components';

import './ContentContainer.scss';

export const ContentContainer = ({
  alert,
  body,
  children,
  className,
  location,
  pageSections,
  title,
}) => {
  const classes = classNames('content-container', className);

  return (
    <div className={classes}>
      <BreadCrumbs homeName='Research Library' location={location} />
      {alert}
      <Section backgroundColor='white' className='title-section'>
        <h1 className='page-title'>{title}</h1>
        <ContentBody body={body} isHTML />
        {children}
      </Section>
      {pageSections}
    </div>
  );
};

ContentContainer.defaultProps = {
  location: {},
};

ContentContainer.propTypes = {
  body: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  alert: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  pageSections: PropTypes.node,
};

export default ContentContainer;
